// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"42f810d6","488":"cb33466d"}[chunkId] + ".chunk.js";
};